<template>
  <div id="form-annual-tax-validated" class="container-form">
    <div class="form-header">
      <p class="form-description">
        Completează formularul de mai jos până pe <strong>25 mai 2026</strong>.
      </p>
      <p class="form-description">
        De restul ne ocupăm noi: vom genera Declarația 230 și o vom depune la ANAF înainte de termenul limită, astfel încât 3,5% din impozitul tău pe venit să fie redirecționat automat către proiectele Recorder.
      </p>
    </div>

    <div class="form-section">
      <div class="row">
        <div class="col-md-12">
          <h4 class="section-title">Pentru ce perioadă dorești să redirecționezi?<span class="required-star">*</span></h4>
          <div class="radio-group">
            <form-radio
              input-name="contractPeriod"
              input-value="1"
              input-id="1"
              input-label="1 an"
              :setInput="setContractPeriod"
              :input-checked="!period2Years"
            ></form-radio>
            <form-radio
              input-name="contractPeriod"
              input-value="2"
              input-id="2"
              input-label="2 ani"
              :setInput="setContractPeriod"
              :input-checked="period2Years"
            ></form-radio>
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="row">
        <div class="col-md-12">
          <h4 class="section-title">Date personale</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 margin-top-15">
          <form-input-validated
            input-type="text"
            input-name="lastName"
            input-label="Nume de familie*"
            :input-value="lastName"
            :setInput="setInputValue"
            :is-valid="validLastName"
            :disabled="false"
            :error-text="lastNameInvalid"
            :force-show-errors="forceShowAllErrors"
            validation-type="required"
          ></form-input-validated>
        </div>
        <div class="col-md-6 margin-top-15">
          <form-input-validated
            input-type="text"
            input-name="firstName"
            input-label="Prenume*"
            :input-value="firstName"
            :setInput="setInputValue"
            :is-valid="validFirstName"
            :disabled="false"
            :error-text="firstNameInvalid"
            :force-show-errors="forceShowAllErrors"
            validation-type="required"
          ></form-input-validated>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 margin-top-15">
          <form-input-validated
            input-name="identityNumber"
            input-type="text"
            input-label="Cod Numeric Personal (CNP)*"
            :input-value="identityNumber"
            :setInput="setInputValue"
            :is-valid="validIdentityNumber"
            :disabled="false"
            :error-text="identityNumberInvalid"
            :force-show-errors="forceShowAllErrors"
            validation-type="cnp"
          ></form-input-validated>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 margin-top-15">
          <form-input-validated
            input-type="email"
            input-name="email"
            input-label="E-mail*"
            :input-value="email"
            :setInput="setInputValue"
            :is-valid="validEmail"
            :disabled="false"
            :error-text="emailInvalid"
            :force-show-errors="forceShowAllErrors"
            validation-type="email"
          ></form-input-validated>
        </div>
        <div class="col-md-6 margin-top-15">
          <form-phone-input
            input-name="phone"
            input-label="Telefon (opțional)"
            :input-value="phone"
            :setInput="setInputValue"
            :is-valid="validPhone"
            :disabled="false"
            :error-text="phoneInvalid"
            placeholder="Număr telefon"
          ></form-phone-input>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="row">
        <div class="col-md-12">
          <h4 class="section-title">Adresa de domiciliu</h4>
          <div class="info-box">
            <div class="recorder-logo-icon">
              <svg class="recorder-logo-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="12" fill="#bd1f23"/>
              </svg>
            </div>
            <span>Introdu adresa așa cum apare în cartea de identitate:</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12 margin-top-15">
          <form-selector-validated
            :selectLabel="countyLabel"
            selectName="county"
            :options="countyOptions"
            :selectedOption="county"
            :selectValue="setCountyValue"
            :error-text="countyInvalid"
            :isValid="validCounty"
            :validate-on-change="true"
            :force-show-errors="forceShowAllErrors"
          ></form-selector-validated>
        </div>
        <div class="col-md-6 col-sm-12 margin-top-15">
          <form-selector-validated
            :selectLabel="localityLabel"
            selectName="locality"
            :options="localityOptions"
            :selectedOption="locality"
            :selectValue="setLocalityValue"
            :error-text="localityInvalid"
            :isValid="validLocality"
            :validate-on-change="true"
            :force-show-errors="forceShowAllErrors"
          ></form-selector-validated>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9 col-sm-12 margin-top-15">
          <form-input-validated
            input-type="text"
            input-name="street"
            input-label="Stradă"
            :input-value="street"
            :setInput="setInputValue"
            :is-valid="validStreet"
            :disabled="false"
            :error-text="streetInvalid"
            :force-show-errors="forceShowAllErrors"
          ></form-input-validated>
        </div>
        <div class="col-md-3 col-sm-12 margin-top-15">
          <form-input-validated
            input-name="number"
            input-type="text"
            input-label="Număr"
            :input-value="number"
            :setInput="setInputValue"
            :is-valid="validNumber"
            :disabled="false"
            :error-text="numberInvalid"
            :force-show-errors="forceShowAllErrors"
            maxlength="10"
          ></form-input-validated>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-12 margin-top-15">
          <form-input
            input-type="text"
            input-name="building"
            input-label="Bloc"
            :input-value="building"
            :setInput="setInputValue"
            :is-valid="validBuilding"
            :disabled="false"
            :error-text="buildingInvalid"
            maxlength="10"
          ></form-input>
        </div>
        <div class="col-md-3 col-sm-12 margin-top-15">
          <form-input
            input-name="entrance"
            input-type="text"
            input-label="Scară"
            :input-value="entrance"
            :setInput="setInputValue"
            :is-valid="validEntrance"
            :disabled="false"
            :error-text="entranceInvalid"
            maxlength="10"
          ></form-input>
        </div>
        <div class="col-md-3 col-sm-12 margin-top-15">
          <form-input
            input-type="text"
            input-name="floor"
            input-label="Etaj"
            :input-value="floor"
            :setInput="setInputValue"
            :is-valid="validFloor"
            :disabled="false"
            :error-text="floorInvalid"
            maxlength="10"
          ></form-input>
        </div>
        <div class="col-md-3 col-sm-12 margin-top-15">
          <form-input
            input-name="apartment"
            input-type="text"
            input-label="Ap."
            :input-value="apartment"
            :setInput="setInputValue"
            :is-valid="validApartment"
            :disabled="false"
            :error-text="apartmentInvalid"
            maxlength="10"
          ></form-input>
        </div>
      </div>
    </div>
    <div class="form-section">
      <div class="row">
        <div class="col-md-12">
          <h4 class="section-title">Semnătură</h4>
          <p class="section-subtitle">
            Semnează formularul folosind mouse-ul sau degetul pe telefon/tabletă.
          </p>
        </div>
      </div>
      <signature-canvas
        signature-label=""
        signature-description=""
        :error-text="signatureInvalid"
        :is-valid="validSignature"
        :save-signature="getSignaturePad"
      ></signature-canvas>
    </div>
    <div class="form-section">
      <div class="row">
        <div class="col-md-12">
          <div class="info-box">
            <div class="recorder-logo-icon">
              <svg class="recorder-logo-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="12" fill="#bd1f23"/>
              </svg>
            </div>
            <span>Începând cu 2025, ANAF poate informa Asociația Recorder Community cu privire la suma donată de către fiecare persoană fizică. Vom putea astfel să îți mulțumim și să ne asigurăm că banii redirecționați de tine chiar ajung la noi.</span>
          </div>
        </div>
      </div>
      <div class="row margin-top-15">
        <div class="col-md-12">
          <form-checkbox
            input-name="dataAcceptance"
            input-value="1"
            input-id="dataAcceptance"
            input-label="Sunt de acord ca datele de identificare pe care le-am completat, precum și suma direcționată să fie comunicate Asociației Recorder Community."
            :setInput="setDataAcceptance"
            :input-checked="checkDataAcceptance"
          ></form-checkbox>
        </div>
      </div>
      <div class="row margin-top-15">
        <div class="col-md-12">
          <div class="checkbox-wrapper">
            <input type="checkbox" name="termsAndConditions" id="termsAndConditions" @input="check" :checked="termsAndConditions"/>
            <label class="label-checkbox" for="termsAndConditions">
              Sunt de acord cu 
              <a href="/termeni-si-conditii-pentru-donatii" target="_blank">Termenele</a> și 
              <a href="/termeni-si-conditii-pentru-donatii" target="_blank">Politica de Confidențialitate</a> ale Asociației.
            </label>
          </div>
          <span class="error" v-if="!validTerms">Această bifă este obligatorie</span>
        </div>
      </div>
    </div>
    <div class="row margin-top-30">
      <div class="col-md-12">
        <button-form
          button-name="Trimite Formularul"
          :on-click="submitForm"
          button-class="full-width"
          :disabled="isSubmitting"
        ></button-form>
      </div>
    </div>
    <notification-toast
      :visible="showNotification"
      :type="notificationType"
      :title="notificationTitle"
      :message="notificationMessage"
      @close="showNotification = false"
    ></notification-toast>
  </div>
</template>

<script>
// Same as FormAnnualTax but with validated components
import FormSelector from "../global/FormSelector";
import FormSelectorValidated from "../global/FormSelectorValidated";
import FormInput from "../global/FormInput";
import FormInputValidated from "../global/FormInputValidated";
import FormPhoneInput from "../global/FormPhoneInput";
import ButtonIcon from "../global/ButtonIcon";
import ButtonForm from "../global/ButtonForm";
import SignatureCanvas from "../global/SignatureCanvas";
import FormCheckbox from "../global/FormCheckbox";
import FormRadio from "../global/FormRadio";
import NotificationToast from "../global/NotificationToast";
import { mapMutations, mapState } from "vuex";
import { notNull, validateEmail, validateCui, validateCNP } from "../../helpers/Validations";
import axios from "axios";
import { submitAnnualTaxForm, logFrontendError } from "../../services/api";
import { saveEmailForAbandonmentTracking, trackFormSubmissionStart, trackFormSubmissionSuccess, trackFormSubmissionError } from '../../utils/tracking';

let signaturePad = null;

export default {
  name: "FormAnnualTaxValidated",
  props: {
    submitSuccessful: Function
  },
  data() {
    return {
      countiesData: [],
      countyOptions: ["Alege județul"],
      localityOptions: ["Alege orașul"],
      selectedCountyAbbr: "",
      countyLabel: "Județ*",
      localityLabel: "Oraș*",
      termsAndConditions: false,
      checkDataAcceptance: false,
      forceShowAllErrors: false, // Force show all errors on submit
      showNotification: false,
      notificationType: 'success',
      notificationTitle: '',
      notificationMessage: '',
      isSubmitting: false
    };
  },
  computed: {
    ...mapState({
      firstName: state => state.formInputs.firstName,
      lastName: state => state.formInputs.lastName,
      email: state => state.formInputs.email,
      phone: state => state.formInputs.phone,
      street: state => state.formInputs.street,
      number: state => state.formInputs.number,
      building: state => state.formInputs.building,
      entrance: state => state.formInputs.entrance,
      floor: state => state.formInputs.floor,
      apartment: state => state.formInputs.apartment,
      county: state => state.formInputs.county,
      locality: state => state.formInputs.locality,
      identityNumber: state => state.formInputs.identityNumber,
      period2Years: state => state.formInputs.period2Years,
      validFirstName: state => state.isFormValid.firstName,
      validLastName: state => state.isFormValid.lastName,
      validEmail: state => state.isFormValid.email,
      validPhone: state => state.isFormValid.phone,
      validStreet: state => state.isFormValid.street,
      validNumber: state => state.isFormValid.number,
      validBuilding: state => state.isFormValid.building,
      validEntrance: state => state.isFormValid.entrance,
      validFloor: state => state.isFormValid.floor,
      validApartment: state => state.isFormValid.apartment,
      validCounty: state => state.isFormValid.county,
      validLocality: state => state.isFormValid.locality,
      validIdentityNumber: state => state.isFormValid.identityNumber,
      validSignature: state => state.isFormValid.signature,
      validTerms: state => state.isFormValid.terms,
      firstNameInvalid: state => !state.isFormValid.firstName ? "Câmp obligatoriu" : "",
      lastNameInvalid: state => !state.isFormValid.lastName ? "Câmp obligatoriu" : "",
      emailInvalid: state => !state.isFormValid.email ? "Email invalid" : "",
      phoneInvalid: state => !state.isFormValid.phone ? "Telefon invalid" : "",
      streetInvalid: state => "", // Street is optional, no error message
      numberInvalid: state => "", // Number is optional, no error message
      buildingInvalid: state => !state.isFormValid.building ? "Câmp obligatoriu" : "",
      entranceInvalid: state => !state.isFormValid.entrance ? "Câmp obligatoriu" : "",
      floorInvalid: state => !state.isFormValid.floor ? "Câmp obligatoriu" : "",
      apartmentInvalid: state => !state.isFormValid.apartment ? "Câmp obligatoriu" : "",
      countyInvalid: state => !state.isFormValid.county ? "Câmp obligatoriu" : "",
      localityInvalid: state => !state.isFormValid.locality ? "Câmp obligatoriu" : "",
      identityNumberInvalid: state => !state.isFormValid.identityNumber ? "CNP sau CUI invalid" : "",
      signatureInvalid: state => !state.isFormValid.signature ? "Semnătura este obligatorie" : ""
    })
  },
  components: {
    FormSelector,
    FormSelectorValidated,
    FormInput,
    FormInputValidated,
    FormPhoneInput,
    ButtonIcon,
    ButtonForm,
    SignatureCanvas,
    FormCheckbox,
    FormRadio,
    NotificationToast
  },
  created() {
    this.submitForm = this.submitForm.bind(this);
    this.submitSuccessfulFunc = this.submitSuccessful.bind(this);
    this.loadCounties();
  },
  watch: {
    county: {
      handler: function(newVal) {
        if (newVal && newVal !== "Alege județul" && newVal !== "" && this.countiesData.length > 0) {
          const selectedCounty = this.countiesData.find(c => c.nume === newVal);
          if (selectedCounty && selectedCounty.abr !== this.selectedCountyAbbr) {
            this.selectedCountyAbbr = selectedCounty.abr;
            this.loadLocalities(selectedCounty.abr);
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations([
      "addFirstName",
      "addLastName",
      "addEmail",
      "addPhone",
      "addSimpleInputField",
      "isFirstNameValid",
      "isLastNameValid",
      "isEmailValid",
      "isPhoneValid",
      "isSimpleInputFieldValid"
    ]),
    setDataAcceptance(event) {
      this.checkDataAcceptance = event.target.checked;
    },
    setContractPeriod(event) {
      if (this.period2Years !== (event.target.value === "2"))
        this.addSimpleInputField([
          "period2Years",
          event.target.value === "2"
        ]);
    },
    check: function (_event) {
      this.termsAndConditions = !this.termsAndConditions;
    },
    setInputValue: function (event) {
      const inputName = event.target.name;
      const inputValue = event.target.value.trim();
      if (this[inputName] !== inputValue)
        this.addSimpleInputField([
          inputName,
          inputValue.toUpperCase()
        ]);
      
      // Save email for potential abandonment tracking (only when user leaves page)
      if (inputName === 'email' && inputValue && inputValue.includes('@')) {
        saveEmailForAbandonmentTracking(inputValue, {
          firstName: this.firstName,
          lastName: this.lastName,
          email: inputValue
        });
      }
      
      // Real-time validation for validated inputs
      this.validateField(inputName, inputValue);
    },
    validateField(name, value) {
      // Real-time validation for all validated fields
      if (name === 'firstName') {
        this.isSimpleInputFieldValid(["firstName", notNull(value)]);
      } else if (name === 'lastName') {
        this.isSimpleInputFieldValid(["lastName", notNull(value)]);
      } else if (name === 'email') {
        this.isSimpleInputFieldValid(["email", validateEmail(value)]);
      } else if (name === 'identityNumber') {
        this.isSimpleInputFieldValid(["identityNumber", validateCui(value) || validateCNP(value)]);
      } else if (name === 'street') {
        // Street is optional, so always valid
        this.isSimpleInputFieldValid(["street", true]);
      } else if (name === 'number') {
        // Number is optional, so always valid
        this.isSimpleInputFieldValid(["number", true]);
      }
      // Note: county and locality are validated in setCountyValue/setLocalityValue
    },
    loadCounties: async function() {
      try {
        const response = await axios.get('/wp-content/themes/recorder/src/json/judete.json');
        this.countiesData = response.data;
        this.countyOptions = ["Alege județul", ...response.data.map(c => c.nume)];
      } catch (error) {
        console.error('Error loading counties:', error);
      }
    },
    setCountyValue: function(value) {
      if (value && value !== "Alege județul") {
        this.addSimpleInputField(["county", value]);
        const selectedCounty = this.countiesData.find(c => c.nume === value);
        if (selectedCounty) {
          this.selectedCountyAbbr = selectedCounty.abr;
          this.loadLocalities(selectedCounty.abr);
        }
        this.isSimpleInputFieldValid(["county", true]);
      } else {
        this.addSimpleInputField(["county", ""]);
        this.localityOptions = ["Alege orașul"];
        this.addSimpleInputField(["locality", ""]);
        this.selectedCountyAbbr = "";
        this.isSimpleInputFieldValid(["county", false]);
      }
    },
    loadLocalities: async function(countyAbbr) {
      try {
        const response = await axios.get(`/wp-content/themes/recorder/src/json/${countyAbbr}.json`);
        this.localityOptions = ["Alege orașul", ...response.data];
        this.addSimpleInputField(["locality", ""]);
      } catch (error) {
        console.error('Error loading localities:', error);
        this.localityOptions = ["Alege orașul"];
      }
    },
    setLocalityValue: function(value) {
      if (value && value !== "Alege orașul") {
        this.addSimpleInputField(["locality", value]);
        this.isSimpleInputFieldValid(["locality", true]);
      } else {
        this.addSimpleInputField(["locality", ""]);
        this.isSimpleInputFieldValid(["locality", false]);
      }
    },
    getSignaturePad: function (object) {
      signaturePad = object;
    },
    submitForm: function (_event) {
      // Prevent multiple submissions
      if (this.isSubmitting) {
        return;
      }
      
      // Force show all errors on submit
      this.forceShowAllErrors = true;
      
      // Validate all fields
      const firstNameValid = notNull(this.firstName);
      this.isSimpleInputFieldValid(["firstName", firstNameValid]);
      const lastNameValid = notNull(this.lastName);
      this.isSimpleInputFieldValid(["lastName", lastNameValid]);
      const emailValid = validateEmail(this.email);
      this.isSimpleInputFieldValid(["email", emailValid]);
      // Street and Number are optional, so always valid
      const streetValid = true;
      this.isSimpleInputFieldValid(["street", streetValid]);
      const numberValid = true;
      this.isSimpleInputFieldValid(["number", numberValid]);
      const countyValid = notNull(this.county) && this.county !== "Alege județul" && this.county !== "";
      this.isSimpleInputFieldValid(["county", countyValid]);
      const localityValid = notNull(this.locality) && this.locality !== "Alege orașul" && this.locality !== "";
      this.isSimpleInputFieldValid(["locality", localityValid]);
      const identityNumberValid = validateCui(this.identityNumber) || validateCNP(this.identityNumber);
      this.isSimpleInputFieldValid(["identityNumber", identityNumberValid]);
      const signatureValid = signaturePad && !signaturePad.isEmpty();
      this.isSimpleInputFieldValid(["signature", signatureValid]);
      this.isSimpleInputFieldValid(["terms", this.termsAndConditions]);

      if (
        this.termsAndConditions &&
        firstNameValid &&
        lastNameValid &&
        emailValid &&
        streetValid &&
        numberValid &&
        countyValid &&
        localityValid &&
        identityNumberValid &&
        signatureValid
      ) {
        // Reset force show errors on successful validation
        this.forceShowAllErrors = false;
        // Send signature as PNG (no compression to avoid JPEG issues)
        const signatureDataURL = signaturePad ? signaturePad.toDataURL() : "";
        const data = {
          firstName: this.firstName,
          lastName: this.lastName,
          phone: this.phone,
          email: this.email,
          street: this.street,
          number: this.number,
          building: this.building,
          entrance: this.entrance,
          floor: this.floor,
          apartment: this.apartment,
          county: this.county,
          locality: this.locality,
          identityNumber: this.identityNumber,
          checkContractPeriod: this.period2Years,
          signature: signatureDataURL,
          checkDataAcceptance: this.checkDataAcceptance
        };
        this.apiCallFillPdf(data);
      } else {
        // Keep forceShowAllErrors true to show all errors
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    apiCallFillPdf: async function (data) {
      this.isSubmitting = true;
      trackFormSubmissionStart();
      
      // Log attempt to submit
      console.log('Starting form submission...', {
        baseURL: 'https://interactionez.ro',
        endpoint: '/submitAnnualTaxForm',
        hasData: !!data,
        dataKeys: data ? Object.keys(data) : [],
        hasSignature: !!(data && data.signature),
        timestamp: new Date().toISOString()
      });
      
      try {
        const response = await submitAnnualTaxForm(data);
        if (response.data && response.data.success) {
          trackFormSubmissionSuccess();
          this.showNotificationToast('success', 'Succes!', 'Formularul a fost trimis cu succes și se procesează. Vei primi email-ul cu formularul completat în scurt timp.');
          this.submitSuccessfulFunc();
          // Email-ul cu PDF va fi trimis automat de worker după generarea PDF-ului
        } else {
          const errorMsg = response.data?.error || 'Eroare necunoscută';
          throw new Error(errorMsg);
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        
        // Determine specific error message
        let errorMessage = 'A apărut o eroare la trimiterea formularului.';
        let errorType = 'unknown';
        let errorDetails = {};
        
        if (error.response) {
          // Server responded with error
          errorType = 'server_error';
          errorDetails = {
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data
          };
          
          if (error.response.status === 429) {
            errorMessage = 'Prea multe cereri. Te rugăm să aștepți câteva minute și să încerci din nou.';
            errorType = 'rate_limit';
          } else if (error.response.status === 400) {
            errorMessage = 'Date invalide. Te rugăm să verifici că toate câmpurile sunt completate corect.';
            errorType = 'validation_error';
            if (error.response.data && error.response.data.errors) {
              errorMessage = 'Erori de validare: ' + error.response.data.errors.join('. ');
            }
          } else if (error.response.status === 500) {
            errorMessage = 'Eroare internă a serverului. Te rugăm să încerci din nou mai târziu.';
            errorType = 'server_internal_error';
          } else if (error.response.status === 403) {
            errorMessage = 'Acces interzis. Te rugăm să verifici configurația.';
            errorType = 'forbidden';
          } else if (error.response.status === 404) {
            errorMessage = 'Endpoint-ul nu a fost găsit. Te rugăm să contactezi suportul.';
            errorType = 'not_found';
          } else if (error.response.data && error.response.data.errors) {
            errorMessage = 'Erori: ' + error.response.data.errors.join('. ');
          } else if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          }
        } else if (error.request) {
          // Request was made but no response received
          errorType = 'network_error';
          errorDetails = {
            requestMade: true,
            noResponse: true
          };
          
          // Check if it's a timeout
          if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
            errorMessage = 'Cererea a expirat. Verifică conexiunea la internet și încearcă din nou.';
            errorType = 'timeout';
          } else if (error.message && error.message.includes('Network Error')) {
            errorMessage = 'Nu s-a putut conecta la server. Verifică conexiunea la internet sau încearcă mai târziu.';
            errorType = 'network_connection_error';
          } else {
            errorMessage = 'Nu s-a putut conecta la server. Verifică conexiunea la internet.';
          }
        } else {
          // Error setting up the request (CORS, etc.)
          errorType = 'request_setup_error';
          errorDetails = {
            message: error.message,
            stack: error.stack
          };
          
          if (error.message && error.message.includes('CORS')) {
            errorMessage = 'Eroare de configurare CORS. Te rugăm să contactezi suportul.';
            errorType = 'cors_error';
          } else if (error.message) {
            errorMessage = 'Eroare la configurarea cererii: ' + error.message;
          }
        }
        
        // Log error to backend with form data (for validation errors especially)
        // Include form data so we can see what was submitted when validation fails
        logFrontendError(errorType, errorMessage, {
          originalError: {
            message: error.message,
            name: error.name,
            code: error.code
          },
          ...errorDetails,
          formDataPresent: !!data,
          hasSignature: !!(data && data.signature)
        }, data); // Pass form data for logging (will be sanitized on backend)
        
        trackFormSubmissionError(errorMessage);
        this.showNotificationToast('error', 'Eroare', errorMessage);
      } finally {
        this.isSubmitting = false;
      }
    },
    showNotificationToast: function(type, title, message) {
      this.notificationType = type;
      this.notificationTitle = title;
      this.notificationMessage = message;
      this.showNotification = true;
    }
  }
};
</script>

<style lang="scss" scoped>
// Base styles copied from FormAnnualTax
.form-header {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #e2e8f0;
}

.form-title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
  line-height: 1.2;
}

.form-description {
  font-size: 16px;
  line-height: 1.7;
  margin-bottom: 16px;
  color: #4a4a4a;
  
  strong {
    font-weight: 700;
    color: #1a1a1a;
  }
}

.form-section {
  margin-bottom: 50px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e5e5e5;
  
  &:last-of-type {
    border-bottom: none;
    margin-bottom: 30px;
  }
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #4a5568;
  line-height: 1.3;
}

.required-star {
  color: #bd1f23;
  margin-left: 3px;
}

.section-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  line-height: 1.6;
}

.info-box {
  background-color: #fee2e2;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #991b1b;
  
  .recorder-logo-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .recorder-logo-svg {
    width: 24px;
    height: 24px;
    display: block;
  }
  
  span {
    font-size: 14px;
    line-height: 1.6;
    color: #991b1b;
  }
}

.radio-group {
  display: flex;
  gap: 40px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.checkbox-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  
  input[type="checkbox"] {
    margin-top: 2px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #0066cc;
    flex-shrink: 0;
  }
  
  label {
    cursor: pointer;
    line-height: 1.6;
    font-size: 14px;
    color: #1a1a1a;
    
    a {
      color: #0066cc;
      text-decoration: underline;
      
      &:hover {
        text-decoration: none;
        color: #0052a3;
      }
    }
  }
}

.error {
  display: block;
  margin: 8px 0 0 0;
  color: #bd1f23;
  font-size: 14px;
}

.margin-top-15 {
  margin-top: 15px !important;
}

.margin-top-30 {
  margin-top: 30px !important;
}

.container-form {
  background-color: #fff;
  padding: 20px 0;
}


@media (max-width: 768px) {
  .form-title {
    font-size: 28px;
  }
  
  .form-header {
    margin-bottom: 40px;
    padding-bottom: 25px;
  }
  
  .form-section {
    margin-bottom: 40px;
    padding-bottom: 30px;
  }
  
  .radio-group {
    flex-direction: column;
    gap: 15px;
  }
}
</style>

